/** Курсор после того же числа сохранённых символов, что и до форматирования. */
export const getFormattedCaretPosition = (
  format: (value: string) => string,
  rawValue: string,
  formattedValue: string,
  rawCaretPosition: number,
): number => {
  const clampedCaretPosition = Math.max(
    0,
    Math.min(rawCaretPosition, rawValue.length),
  );
  const preservedCharactersCount = format(
    rawValue.substring(0, clampedCaretPosition),
  ).length;

  if (preservedCharactersCount === 0) {
    return 0;
  }

  for (
    let caretPosition = 1;
    caretPosition <= formattedValue.length;
    caretPosition += 1
  ) {
    const formattedPrefix = formattedValue.substring(0, caretPosition);

    if (format(formattedPrefix).length >= preservedCharactersCount) {
      return caretPosition;
    }
  }

  return formattedValue.length;
};
